// 引入ElementPlus所有图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { createApp } from 'vue';
import ElementPlusX from 'vue-element-plus-x';
import App from './App.vue';
import { i18n } from './locales';
import router from './routers';
import store from './stores';
import './styles/index.scss';
import 'virtual:uno.css';
import 'element-plus/dist/index.css';

// SVG插件配置
import 'virtual:svg-icons-register';

// 开发环境下引入测试文件
if (import.meta.env.DEV) {
  import('./api/agent/test');
}

const app = createApp(App);

app.use(router);
app.use(ElementPlusX);
app.use(i18n);
// 注册ElementPlus所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(store);

app.mount('#app');
